import { render, staticRenderFns } from "./RecommendLayer.vue?vue&type=template&id=09d78293&scoped=true&"
import script from "./RecommendLayer.vue?vue&type=script&lang=js&"
export * from "./RecommendLayer.vue?vue&type=script&lang=js&"
import style0 from "./RecommendLayer.vue?vue&type=style&index=0&id=09d78293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d78293",
  null
  
)

export default component.exports